import * as styles from "./AutocompleteItem.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Autocomplete as BaseAutocomplete } from "@base-ui/react/autocomplete";

import type { AutocompleteItemProps } from "./Autocomplete.types";

export function AutocompleteItem({
  className,
  children,
  ref,
  ...props
}: AutocompleteItemProps): JSX.Element {
  return (
    <BaseAutocomplete.Item
      data-slot="autocomplete-item"
      className={clsx(styles.item, className)}
      ref={ref}
      {...props}
    >
      <span className={styles.itemText}>{children}</span>
    </BaseAutocomplete.Item>
  );
}
